<script>
    import { allProjectFields, allTemplateFields } from "../../Participaid.svelte";
    import ProjectField from "../../models/participaid/ProjectField.js";

    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Reporter from "../../lib/error.js";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let fields = [];
    export let project;
    export let selectedFieldId = "";
    export let selectedField;
    export let label = "Choose entry type";
    export let help = "";

    console.log(`initializing ProjectFieldDropdown with selected field ID: ${selectedFieldId}`);
    console.log(`Selected field:`);
    console.log(selectedField);

    // watch for changes in selected field id,
    // and update exported var containing the field
    // object correspondingly
    $: if (selectedFieldId && fields.length) {
        (fields || []).forEach(field => {
            if (field.id == selectedFieldId) {
                //debugger;
                selectedField = field;
            }
        });
    }

    let errorResult;
    let templateFieldsRequest;

    function dbgFID() {
        console.log(`current selected field ID: ${selectedFieldId}`)
    }

    function handleResponseOk(res) {
        console.log(`[ProjectFieldDropdown] successfully retrieved template fields for project`);
        console.log(res);

        fields = res.data.projectFields
    }

    if (!fields || fields.length < 1) {
        console.assert(!!project, "expected ProjectFieldDropdown to be given Project when not given [Field]");

        templateFieldsRequest = allProjectFields(project.id)
            .then(handleResponseOk)

            // TODO: resolve errors on this call o we dont have to handle a successful response in the catch
            .catch(res => {
                if (res.data && res.data.projectFields) {
                    console.warn(`TODO: fix templateFields() GraphQL call to not return error`);
                    handleResponseOk(res);
                }
                else {
                    errorResult = res;
                    Reporter.error(`[ProjectFieldDropdown] there was an error fetching TemplateFields for project #${project.id}`, res);
                }
            })
    }

</script>

{#if fields.length}
    <!-- TODO: for some reason it returns the text value instead of the option avlue -->
    <Select enhanced variant="outlined" withLeadingIcon bind:value={selectedFieldId} {label} style="width: 100%">
        <span slot="icon"><Icon class="material-icons">work</Icon></span>
        {#if templateFieldsRequest}
            {#await templateFieldsRequest}
                <Option
                        value="loading..."
                        selected={true}>
                    loading...
                </Option>
            {/await}
        {/if}
        {#each fields as field}
            {#if !ProjectField.isMetaField(field)}
                <Option
                        value={field.id}
                        selected={selectedFieldId == field.id}>
                    {field.name}
                </Option>
            {/if}
        {/each}
    </Select>
{:else}
    loading...
{/if}

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>{help}</HelperText>
{/if}